import { useMutation, useQueryClient } from '@tanstack/react-query';
import getFetchWrapper from '../helpers/getFetchWrapperWithTrackingId';
import { accountSummaryV2CacheKey } from 'syf-api/api/cacheKeys';
import { planEnrollmentUrl } from '../const/api-endpoints';
import { useMainContext } from '../context';
import { HttpMethod } from '../const/http-method';
import { onInvalidate } from '../helpers/enrollment';
var usePlanEnrollment = function () {
    var _a = useMainContext(), accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config;
    var fetchWrapper = getFetchWrapper(config, accountId);
    var queryClient = useQueryClient();
    return useMutation({
        mutationKey: [planEnrollmentUrl, { accountId: accountId, accountIdType: accountIdType }],
        mutationFn: function () {
            return fetchWrapper(planEnrollmentUrl, {
                body: JSON.stringify({
                    'cipher.accountId': accountId,
                    accountIdType: 'guid',
                    acceptTerms: true
                }),
                method: HttpMethod.POST
            });
        },
        onError: function (err) { return onInvalidate({ err: err }); },
        onSuccess: function () {
            return onInvalidate({
                queryClient: queryClient,
                cacheKey: accountSummaryV2CacheKey({ accountId: accountId, accountIdType: accountIdType })
            });
        }
    });
};
export default usePlanEnrollment;
//# sourceMappingURL=use-plan-eligibility-enrollment.js.map